import OperatingModeRequestModelBase from '../_generated/modelBases/operating-mode-request-model-base';

export default class OperatingModeRequestModel extends OperatingModeRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
